<div class="row">
    <div class="col-12 col-md-6">
        <div class="card rounded-0">
            <div class="card-body">
                <form #f="ngForm" (ngSubmit)="submit()" novalidate>
                    <h3 class="fs-4 fw-bold">Payment Gateway</h3>
                    <div class="mb-3">
                        <label for="name" class="form-label">Name <em>*</em></label>
                        <input type="text" class="form-control" name="name" #name="ngModel" [(ngModel)]="data.name"
                            required />
                    </div>
                    <div class="mb-3">
                        <label for="name" class="form-label">Icon</label>
                        <app-image-uploader [loadImage]="data.icon" [type]="'single'"
                            (uploadEvent)="uploadDirect($event, 'icon', true)"
                            (deleteEvent)="deleteDirect($event, 'icon')"></app-image-uploader>
                    </div>
                    <div class="mb-3">
                        <label for="provider" class="form-label">Provider <em>*</em></label>
                        <select class="form-control" name="provider" #provider="ngModel"
                            [(ngModel)]="data.provider_uuid" required (change)="getField($event)">
                            <option [value]="provider.uuid" *ngFor="let provider of providers">{{provider.name}}
                            </option>
                        </select>
                    </div>

                    <div class="mb-3">
                        <label for="sort" class="form-label">Sort</label>
                        <input type="number" class="form-control" name="sort" #sort="ngModel" [(ngModel)]="data.sort" />
                    </div>
                    <div class="mb-3" *ngIf="(data.auto || selectedProviderType === 'i1qr') && banks.length > 0">
                        <label for="bank" class="form-label">Bank <em>*</em></label>
                        <select class="form-control" name="bank" #bank="ngModel" [(ngModel)]="data.bank_id" required>
                            <option [value]="bank.id" *ngFor="let bank of banks">{{bank.title}}</option>
                        </select>
                    </div>


                    <div *ngIf="fields.length > 0">
                        <p>Integration Setting</p>
                        <hr class="mb-3" />
                        <ng-container *ngFor="let field of fields">

                            <!-- sky99: gateway_code is selected per-deposit by the player, hide static field -->
                            <div [ngSwitch]="field.type"
                                *ngIf="shouldShowField(field)">

                                <div class="mb-3" *ngSwitchCase="'image'">
                                    <label [for]="field.identifier" class="form-label">{{field.name}} <em>*</em></label>
                                    <app-image-uploader [loadImage]="data.config[field.identifier]" [type]="'single'"
                                        (uploadEvent)="upload($event, field.identifier, true)"
                                        (deleteEvent)="delete($event, field.identifier)"></app-image-uploader>
                                </div>

                                <div class="mb-3" *ngSwitchCase="'number'">
                                    <label [for]="field.identifier" class="form-label">{{field.name}} <em>*</em></label>
                                    <input type="number" class="form-control" [name]="field.identifier"
                                        [(ngModel)]="data.config[field.identifier]" required />
                                </div>

                                <div class="mb-3" *ngSwitchCase="'textarea'">
                                    <label [for]="field.identifier" class="form-label">{{field.name}} <em>*</em></label>
                                    <quill-editor [format]="'html'" [name]="field.identifier"
                                        [(ngModel)]="data.config[field.identifier]" [required]="true"
                                        [styles]="{minHeight: '250px'}"
                                        (onEditorCreated)="editorCreated($event, field.identifier)"></quill-editor>
                                </div>

                                <div *ngSwitchCase="'popup'">
                                    <div class="mb-3" *ngIf="field.default_value" [innerHTML]="field.default_value">
                                    </div>
                                </div>

                                <div *ngSwitchCase="'select'" class="mb-3">
                                    <label [for]="field.identifier" class="form-label">{{field.name}} <em>*</em></label>
                                    <select class="form-control" [name]="field.identifier"
                                        [(ngModel)]="data.config[field.identifier]" required>
                                        <option [value]="option.value" *ngFor="let option of field.options">
                                            {{option.label}}</option>
                                    </select>
                                </div>

                                <div *ngSwitchDefault class="mb-3">
                                    <label [for]="field.key" class="form-label">{{field.name}} <em>*</em></label>
                                    <input type="text" class="form-control" [name]="field.identifier"
                                        [(ngModel)]="data.config[field.identifier]" required />
                                </div>

                            </div>

                        </ng-container>
                        <hr class="mb-3" />

                    </div>

                    <!-- Callback URLs to give the payment provider (copy-ready) -->
                    <div *ngIf="callbackUrls.length > 0" class="mb-3">
                        <p class="mb-1">Callback / Return URLs</p>
                        <small class="text-muted d-block mb-2">Give these to the payment provider when applying. Each is scoped to this company automatically.</small>
                        <div class="mb-2" *ngFor="let item of callbackUrls">
                            <label class="form-label mb-1">{{item.label}}</label>
                            <div class="input-group">
                                <input type="text" class="form-control" [value]="item.url" readonly
                                    (focus)="$any($event.target).select()" />
                                <button type="button" class="btn btn-outline-secondary"
                                    (click)="copyCallbackUrl(item.url)">
                                    {{ copiedUrl === item.url ? 'Copied!' : 'Copy' }}
                                </button>
                            </div>
                        </div>
                        <hr class="mb-3" />
                    </div>


                    <!-- Sky99: available payment method selector -->
                    <div *ngIf="selectedProviderType === 'sky99'" class="mb-3">
                        <p>Sky99 Payment Methods</p>
                        <hr class="mb-2" />
                        <button type="button" class="btn btn-outline-secondary btn-sm mb-2"
                            (click)="loadSky99Methods()" [disabled]="sky99MethodsLoading">
                            {{ sky99MethodsLoading ? 'Loading...' : 'Load Available Methods' }}
                        </button>
                        <div *ngIf="sky99MethodsError" class="text-danger small mb-2">{{ sky99MethodsError }}</div>
                        <div style="overflow-x: auto; margin: 0 -4px;">
                        <table *ngIf="sky99Methods.length > 0" class="table table-sm table-borderless mb-2" style="min-width: 260px">
                            <thead>
                                <tr class="small text-muted">
                                    <th style="width:30px"></th>
                                    <th>Method</th>
                                    <th style="width:110px" class="text-center">Gateway Fee %</th>
                                    <th style="width:130px" class="text-center">Withdraw GW Fee %</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let method of sky99Methods">
                                    <td class="align-middle">
                                        <input class="form-check-input m-0" type="checkbox" [id]="'m_' + method.code"
                                            [checked]="isSky99MethodEnabled(method.code)"
                                            (change)="toggleSky99Method(method, $any($event.target).checked)" />
                                    </td>
                                    <td class="align-middle">
                                        <label class="form-check-label mb-0" [for]="'m_' + method.code">{{ method.code }}</label>
                                    </td>
                                    <td class="align-middle">
                                        <input type="number" class="form-control form-control-sm"
                                            min="0" max="100" step="0.01" placeholder="0.00"
                                            [disabled]="!isSky99MethodEnabled(method.code)"
                                            [value]="isSky99MethodEnabled(method.code) ? getSky99MethodRate(method.code) : null"
                                            (input)="setSky99MethodRate(method.code, $any($event.target).value)" />
                                    </td>
                                    <td class="align-middle">
                                        <input type="number" class="form-control form-control-sm"
                                            min="0" max="100" step="0.01" placeholder="0.00"
                                            [disabled]="!isSky99MethodEnabled(method.code)"
                                            [value]="isSky99MethodEnabled(method.code) ? getSky99MethodWithdrawRate(method.code) : null"
                                            (input)="setSky99MethodWithdrawRate(method.code, $any($event.target).value)" />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        </div>
                        <div *ngIf="data.config?.enabled_methods?.length > 0 && sky99Methods.length === 0"
                            class="small text-muted">
                            {{ data.config.enabled_methods.length }} method(s) saved. Click "Load Available Methods" to review.
                        </div>
                        <hr class="mt-3 mb-3" />
                    </div>

                    <!-- Novapay: editable gateway fees per channel -->
                    <div *ngIf="selectedProviderType === 'novapay'" class="mb-3">
                        <p>Novapay Payment Channel</p>
                        <hr class="mb-2" />
                        <div style="overflow-x: auto; margin: 0 -4px;">
                            <table class="table table-sm table-bordered mb-3" style="min-width: 760px">
                                <thead>
                                    <tr class="small text-muted">
                                        <th>Channel Name</th>
                                        <th style="width:95px">ChannelID</th>
                                        <th style="width:90px">Currency</th>
                                        <th style="width:110px">Minimum</th>
                                        <th style="width:110px">Maximum</th>
                                        <th style="width:150px">Gateway Fee %</th>
                                        <th style="width:150px">Min Fee</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let method of novapayDepositMethods">
                                        <td class="align-middle">{{ method.name }}</td>
                                        <td class="align-middle">{{ method.code }}</td>
                                        <td class="align-middle">{{ data.config.currency || 'MYR' }}</td>
                                        <td class="align-middle">{{ method.min }}</td>
                                        <td class="align-middle">{{ method.max }}</td>
                                        <td class="align-middle">
                                            <input type="number" class="form-control form-control-sm"
                                                min="0" max="100" step="0.01" placeholder="0.00"
                                                [value]="getNovapayMethodGatewayFeeRate(method.code)"
                                                (input)="setNovapayMethodGatewayFeeRate(method.code, $any($event.target).value)" />
                                        </td>
                                        <td class="align-middle">
                                            <input type="number" class="form-control form-control-sm"
                                                min="0" step="0.01" placeholder="0.00"
                                                [value]="getNovapayMethodGatewayMinFee(method.code)"
                                                (input)="setNovapayMethodGatewayMinFee(method.code, $any($event.target).value)" />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <p>Novapay Payout Channel</p>
                        <div style="overflow-x: auto; margin: 0 -4px;">
                            <table class="table table-sm table-bordered mb-2" style="min-width: 560px">
                                <thead>
                                    <tr class="small text-muted">
                                        <th style="width:45px"></th>
                                        <th>Channel Name</th>
                                        <th style="width:95px">ChannelID</th>
                                        <th style="width:110px">Minimum</th>
                                        <th style="width:110px">Maximum</th>
                                        <th style="width:150px">Gateway Fee %</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let method of novapayPayoutMethods">
                                        <td class="align-middle text-center">
                                            <input class="form-check-input m-0" type="radio" name="novapay_outid"
                                                [value]="method.code" [(ngModel)]="data.config.outid" />
                                        </td>
                                        <td class="align-middle">{{ method.name }}</td>
                                        <td class="align-middle">{{ method.code }}</td>
                                        <td class="align-middle">{{ method.min }}</td>
                                        <td class="align-middle">{{ method.max }}</td>
                                        <td class="align-middle">
                                            <input type="number" step="0.01" min="0" max="100"
                                                class="form-control form-control-sm" name="novapay_gateway_withdraw_fee_rate"
                                                [(ngModel)]="data.config.gateway_withdraw_fee_rate" placeholder="0.00" />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <hr class="mt-3 mb-3" />
                    </div>

                    <div class="mb-3" *ngIf="selectedProviderType === 'bbpay'">
                        <label for="bbpay_p2p_rate" class="form-label">BBPay P2P Gateway Fee (%)</label>
                        <input id="bbpay_p2p_rate" type="number" step="0.01" min="0" max="100" required class="form-control mb-3"
                            name="bbpay_p2p_rate" [(ngModel)]="data.config.bbpay_p2p_rate" />
                        <label for="bbpay_qr_rate" class="form-label">BBPay QR Gateway Fee (%)</label>
                        <input id="bbpay_qr_rate" type="number" step="0.01" min="0" max="100" required class="form-control"
                            name="bbpay_qr_rate" [(ngModel)]="data.config.bbpay_qr_rate" />
                        <small class="text-muted">Applied to successful deposits using the channel confirmed by BBPay. Unidentified channels use BBPay's reported fee.</small>
                    </div>
                    <div class="mb-3" *ngIf="selectedProviderType !== 'sky99' && selectedProviderType !== 'novapay' && selectedProviderType !== 'bbpay'">
                        <label for="topup_rate" class="form-label">Gateway Fee (%) <small class="text-muted">Fee per success topup</small></label>
                        <input type="number" step="0.01" min="0" max="100" class="form-control" name="topup_rate" [(ngModel)]="data.config.topup_rate" placeholder="e.g. 1.5" />
                    </div>
                    <div class="mb-3" *ngIf="selectedProviderType !== 'sky99' && selectedProviderType !== 'novapay' && selectedProviderType !== 'bbpay'">
                        <label for="withdraw_rate" class="form-label">Withdraw Gateway Fee (%) <small class="text-muted">Fee per success withdraw</small></label>
                        <input type="number" step="0.01" min="0" max="100" class="form-control" name="withdraw_rate" [(ngModel)]="data.config.withdraw_rate" placeholder="e.g. 1.5" />
                    </div>
                    <hr class="mb-3" />

                    <div class="mb-3">
                        <label for="status" class="form-label">Status <em>*</em></label>
                        <select class="form-control" name="status" #status="ngModel" [(ngModel)]="data.status" required>
                            <option [value]="1">Enabled</option>
                            <option [value]="0">Disabled</option>
                        </select>
                    </div>
                    <button type="submit" class="btn btn-primary w-100">Save</button>
                </form>
            </div>
        </div>
    </div>
</div>
